<template>
  <div>
    <!-- :label="propertiesData.label" :dark="propertiesData.dark" :color="propertiesData.color"-->
    <v-chip
      v-for="(prop, index) in properties"
      :label="prop.label"
      :dark="prop.dark"
      :color="prop.color"
      :key="index"      
    >
      {{ prop.dataText }}
      <v-icon> {{ prop.icon }} </v-icon>
    </v-chip>
  </div>
</template>
<script>
export default {
  name: "ComChipSimulador",
  props: {
    properties: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data: () => ({}),
  methods: {},
};
</script>

<style></style>
